<template>
  <Toast/>
  <div class="flex flex-col min-h-screen">
  <header>
    <div class="h-full bg-surface-50 dark:bg-surface-950">
      <div
          class="bg-surface-0 dark:bg-surface-900 py-4 px-12 border-b border-surface-200 dark:border-surface-800 flex items-center justify-between relative lg:static">
        <RouterLink to="/">
          <div class="flex items-center gap-4 py-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.84219 2.87829C5.69766 3.67858 4.6627 4.62478 3.76426 5.68992C7.4357 5.34906 12.1001 5.90564 17.5155 8.61335C23.2984 11.5047 27.955 11.6025 31.1958 10.9773C30.9017 10.087 30.5315 9.23135 30.093 8.41791C26.3832 8.80919 21.6272 8.29127 16.0845 5.51998C12.5648 3.76014 9.46221 3.03521 6.84219 2.87829ZM27.9259 5.33332C24.9962 2.06 20.7387 0 16 0C14.6084 0 13.2581 0.177686 11.9709 0.511584C13.7143 0.987269 15.5663 1.68319 17.5155 2.65781C21.5736 4.68682 25.0771 5.34013 27.9259 5.33332ZM31.8887 14.1025C27.9735 14.8756 22.567 14.7168 16.0845 11.4755C10.024 8.44527 5.20035 8.48343 1.94712 9.20639C1.7792 9.24367 1.61523 9.28287 1.45522 9.32367C1.0293 10.25 0.689308 11.2241 0.445362 12.2356C0.705909 12.166 0.975145 12.0998 1.25293 12.0381C5.19966 11.161 10.7761 11.1991 17.5155 14.5689C23.5761 17.5991 28.3997 17.561 31.6529 16.838C31.7644 16.8133 31.8742 16.7877 31.9822 16.7613C31.9941 16.509 32 16.2552 32 16C32 15.358 31.9622 14.7248 31.8887 14.1025ZM31.4598 20.1378C27.5826 20.8157 22.3336 20.5555 16.0845 17.431C10.024 14.4008 5.20035 14.439 1.94712 15.1619C1.225 15.3223 0.575392 15.5178 0.002344 15.7241C0.000781601 15.8158 0 15.9078 0 16C0 24.8366 7.16344 32 16 32C23.4057 32 29.6362 26.9687 31.4598 20.1378Z"
                  class="fill-surface-900 dark:fill-surface-0"
              />
            </svg>
            <span class="text-xl font-medium text-surface-900 dark:text-surface-0">AELIOS</span>
          </div>
        </RouterLink>
        <a
            v-styleclass="{
                    selector: '@next',
                    enterFromClass: 'hidden',
                    leaveToClass: 'hidden',
                    hideOnOutsideClick: true
                }"
            class="cursor-pointer block lg:hidden text-surface-700 dark:text-surface-100 mt-1"
        >
          <i class="pi pi-bars !text-2xl"/>
        </a>
        <div
            class="items-center grow justify-between hidden lg:flex absolute lg:static w-full bg-surface-0 dark:bg-surface-900 left-0 top-full px-12 lg:px-0 z-50 shadow lg:shadow-none">
          
          
          <div class="list-none p-0 py-4 lg:py-0 m-0 flex grow lg:items-center lg:justify-center text-surface-900 dark:text-surface-0 select-none flex-col lg:flex-row cursor-pointer">
            <Suspense>
              <Tag :value="auth.user?.kioskModeSiteName.toUpperCase()" severity="info" />
              <template #fallback>
                <<Skeleton width="50" height="10" />
              </template>
            </Suspense>
          </div>
          <div class="flex border-t lg:border-t-0 border-surface py-4 lg:py-0 mt-4 lg:mt-0 gap-4">
              <Button severity="secondary" outlined label="Log out" @click="logout"/>
          </div>
        </div>
      </div>
    </div>
  </header>
  <main class="flex-1 relative">
    <router-view />
  </main>
  </div>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import Pusher from 'pusher-js';
import {useAuthStore} from '@/stores/auth';

const auth = useAuthStore();
const router = useRouter();
const darkModeToggleIcon = ref('fa-sharp fa-light fa-moon');

let pusher;
let channels = [];

const ToggleDarkMode = () => {
  document.documentElement.classList.toggle('my-app-dark');
  darkModeToggleIcon.value = document.documentElement.classList.contains('my-app-dark') ? 'fa-sharp fa-light fa-moon' : 'fa-sharp fa-light fa-sun-bright';
}

const logout = async () => {
  try {
    await auth.logoutKiosk(localStorage.getItem('kiosk_instance_id'));
    
    await router.push({ name: 'kiosk-mode-login' });
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

onMounted(async () => {

  pusher = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
    cluster: import.meta.env.VITE_PUSHER_CLUSTER,
    auth: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}` // or your auth token
      }
    }});

  // Company channel
  const companyChannel = pusher.subscribe(`company.${auth.user.companyId}`);
  companyChannel.bind('scan-credits-updated', (data) => {
    scanCreditsRemaining.value = data.scanCreditsRemaining;
    scanCreditsWarningLevel.value = data.scanCreditsWarningLevel;
  });
  channels.push(companyChannel);
  
  // if (localStorage.getItem('dark_mode') === 'true') {
  //   document.documentElement.classList.add('my-app-dark');
  // }
  // SetDarkModeIcon();

});

onBeforeUnmount(() => {
  channels.forEach((ch) => {
    ch.unbind_all();
    pusher.unsubscribe(ch.name);
  });
  pusher.disconnect();
});
</script>

<style scoped>

</style>